import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';

type ClerkProviderWithRouterProps = {
  children: React.ReactNode;
};

const publishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!publishableKey) {
  throw new Error('Missing REACT_APP_CLERK_PUBLISHABLE_KEY');
}

const ClerkProviderWithRouter: React.FC<ClerkProviderWithRouterProps> = ({ children }) => {
  return (
    <ClerkProvider publishableKey={publishableKey}>
      {children}
    </ClerkProvider>
  );
};

export default ClerkProviderWithRouter;
